<template>
  <div class="screen-list">
    <img class="logo" src="@/assets/img/ASELogo_02.png" alt="" />

    <loading :active.sync="isLoading" loader="dots"></loading>
    <template v-if="tvData && tvData.FormatId === 1">
      <div
        v-if="tvData.Sorts[0].Frames[0].Type === 1"
        class="yahome-table-wrap"
        style="height: 100%; width: 100%; padding: 0"
      >
        <el-table
          :data="
            rows.slice((currentPage - 1) * pageSize, currentPage * pageSize)
          "
          style="width: 100%"
        >
          <el-table-column prop="BlurName" label="姓名" align="center">
          </el-table-column>
          <el-table-column label="目前階段名稱" align="center">
            <template slot-scope="props">
              <template
                v-if="props.row.NowStageName !== null && props.row.NowStageName"
              >
                <div v-if="props.row.NowStageName.split('(').length > 1">
                  <span>{{ props.row.NowStageName.split("(")[0] }}</span>
                  <br />
                  <span>({{ props.row.NowStageName.split("(")[1] }}</span>
                </div>
                <div v-else>
                  {{ props.row.NowStageName }}
                </div>
              </template>
              <template v-else> {{ props.row.NowStageName }}</template>
            </template>
          </el-table-column>
          <el-table-column label="下個階段名稱" align="center">
            <template slot-scope="props">
              <template
                v-if="
                  props.row.NextStageName !== null && props.row.NextStageName
                "
              >
                <div v-if="props.row.NextStageName.split('(').length > 1">
                  <span>{{ props.row.NextStageName.split("(")[0] }}</span>
                  <br />
                  <span>({{ props.row.NextStageName.split("(")[1] }}</span>
                </div>
                <div v-else>
                  {{ props.row.NextStageName }}
                </div>
              </template>
              <template v-else> {{ props.row.NextStageName }}</template>
            </template>
          </el-table-column>
          <el-table-column
            prop="NextStageExpectStartTime"
            :formatter="timeFormatter"
            align="center"
            label="下個階段開始時間"
          >
          </el-table-column>
          <el-table-column
            prop="FlowExpectEndTime"
            :formatter="timeFormatter"
            align="center"
            label="本日結束時間"
          >
          </el-table-column>
        </el-table>

        <div class="text-right">
          第{{ currentPage }}頁，共{{ Math.ceil(rows.length / pageSize) }}頁
        </div>
      </div>
      <video
        v-if="tvData.Sorts[0].Frames[0].Type === 3"
        ref="videoRef0"
        :src="tvData.Sorts[0].Frames[0].Value"
        width="100%"
        height="100%"
        muted="muted"
        loop="loop"
        controls
      >
        <!-- 加入字幕 track -->
        <track src="" kind="subtitles" srclang="zh" label="No item" default />
        <!-- 加入視覺描述 track（給視障者輔助） -->
        <track src="" kind="descriptions" srclang="en" label="No item" />
      </video>
      <img
        v-if="tvData.Sorts[0].Frames[0].Type === 4"
        :src="tvData.Sorts[0].Frames[0].Value"
        alt=""
      />
    </template>

    <div class="screen-wrap" v-if="tvData && tvData.FormatId === 2">
      <!-- 左上 -->
      <div
        class="screen"
        v-if="tvData.Sorts[0].Frames.length > 0"
        :class="{
          h100:
            tvData.Sorts[1].Frames.length === 0 &&
            tvData.Sorts[0].Frames[0].Type === 1,
        }"
      >
        <div
          v-if="tvData.Sorts[0].Frames[0].Type === 1"
          class="yahome-table-wrap"
          style="height: 100%; padding: 0"
        >
          <el-table
            :data="
              rows.slice((currentPage - 1) * pageSize, currentPage * pageSize)
            "
            style="width: 100%"
          >
            <el-table-column
              prop="BlurName"
              label="姓名"
              align="center"
              width="120"
            >
              <template slot-scope="props">
                <!-- 如果是中文 -->
                <template v-if="checkIsChinese(props.row.BlurName)">
                  <span v-if="props.row.BlurName.length <= 4">
                    {{ props.row.BlurName }}</span
                  >
                  <span v-if="props.row.BlurName.length > 4">{{
                    props.row.BlurName.substr(0, 4)
                  }}</span>
                </template>
                <!-- 如果是英文 -->
                <template v-if="!checkIsChinese(props.row.BlurName)">
                  <template
                    v-for="(splitName, index) in props.row.BlurName.split(' ')"
                  >
                    <span :key="index" v-if="index < 2" style="display: block">
                      <span v-if="splitName.length <= 8"> {{ splitName }}</span>
                      <span v-else>{{ splitName.substr(0, 7) }}..</span>
                    </span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="目前階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NowStageName !== null && props.row.NowStageName
                  "
                >
                  <div v-if="props.row.NowStageName.split('(').length > 1">
                    <span>{{ props.row.NowStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NowStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NowStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NowStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column label="下個階段名稱" align="center" width="138">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NextStageName !== null && props.row.NextStageName
                  "
                >
                  <div v-if="props.row.NextStageName.split('(').length > 1">
                    <span>{{ props.row.NextStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NextStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NextStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NextStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column
              prop="NextStageExpectStartTime"
              :formatter="timeFormatter"
              align="center"
              label="下個階段開始時間"
              class="tColumnNonPadding"
              width="147"
            >
            </el-table-column>
            <el-table-column
              prop="FlowExpectEndTime"
              :formatter="timeFormatter"
              align="center"
              label="本日結束時間"
              width="120"
            >
            </el-table-column>
          </el-table>
          <div class="text-right lower-right">
            第{{ currentPage }}頁，共{{ Math.ceil(rows.length / pageSize) }}頁
          </div>
        </div>
        <video
          v-if="tvData.Sorts[0].Frames[0].Type === 3"
          ref="videoRef0"
          :src="tvData.Sorts[0].Frames[0].Value"
          width="100%"
          height="100%"
          muted="muted"
          loop="loop"
          controls
        >
          <!-- 加入字幕 track -->
          <track src="" kind="subtitles" srclang="zh" label="No item" default />
          <!-- 加入視覺描述 track（給視障者輔助） -->
          <track src="" kind="descriptions" srclang="en" label="No item" />
        </video>

        <img
          v-if="tvData.Sorts[0].Frames[0].Type === 4"
          :src="tvData.Sorts[0].Frames[0].Value"
          alt=""
        />
      </div>
      <!-- 左下 -->
      <div
        class="screen"
        v-if="tvData.Sorts[1].Frames.length > 0"
        :class="{
          h100:
            tvData.Sorts[0].Frames.length === 0 &&
            tvData.Sorts[1].Frames[0].Type === 1,
        }"
      >
        <div
          v-if="tvData.Sorts[1].Frames[0].Type === 1"
          class="yahome-table-wrap"
          style="height: 100%; padding: 0"
        >
          <el-table
            :data="
              rows.slice((currentPage - 1) * pageSize, currentPage * pageSize)
            "
            style="width: 100%"
          >
            <el-table-column
              prop="BlurName"
              label="姓名"
              align="center"
              width="110"
            >
            </el-table-column>
            <el-table-column label="目前階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NowStageName !== null && props.row.NowStageName
                  "
                >
                  <div v-if="props.row.NowStageName.split('(').length > 1">
                    <span>{{ props.row.NowStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NowStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NowStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NowStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column label="下個階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NextStageName !== null && props.row.NextStageName
                  "
                >
                  <div v-if="props.row.NextStageName.split('(').length > 1">
                    <span>{{ props.row.NextStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NextStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NextStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NextStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column
              prop="NextStageExpectStartTime"
              :formatter="timeFormatter"
              align="center"
              label="下個階段開始時間"
            >
            </el-table-column>
            <el-table-column
              prop="FlowExpectEndTime"
              :formatter="timeFormatter"
              align="center"
              label="本日結束時間"
            >
            </el-table-column>
          </el-table>
          <div class="text-right">
            第{{ currentPage }}頁，共{{ Math.ceil(rows.length / pageSize) }}頁
          </div>
        </div>

        <video
          :key="tvData.Sorts[1].Frames[0].Value"
          v-if="tvData.Sorts[1].Frames[0].Type === 3"
          ref="videoRef1"
          :src="tvData.Sorts[1].Frames[0].Value"
          width="100%"
          height="100%"
          muted="muted"
          loop="loop"
          controls
        >
          <!-- 加入字幕 track -->
          <track src="" kind="subtitles" srclang="zh" label="No item" default />
          <!-- 加入視覺描述 track（給視障者輔助） -->
          <track src="" kind="descriptions" srclang="en" label="No item" />
        </video>

        <img
          v-if="tvData.Sorts[1].Frames[0].Type === 4"
          :src="tvData.Sorts[1].Frames[0].Value"
          alt=""
        />
      </div>
    </div>

    <div class="screen-wrap" v-if="tvData && tvData.FormatId === 2">
      <!-- 右上 -->
      <div
        class="screen"
        v-if="tvData.Sorts[2].Frames.length > 0"
        :class="{
          h100:
            tvData.Sorts[3].Frames.length === 0 &&
            tvData.Sorts[2].Frames[0].Type === 1,
        }"
      >
        <div
          v-if="tvData.Sorts[2].Frames[0].Type === 1"
          class="yahome-table-wrap"
          style="height: 100%; padding: 0"
        >
          <el-table
            :data="
              rows.slice((currentPage - 1) * pageSize, currentPage * pageSize)
            "
            style="width: 100%"
          >
            <el-table-column
              prop="BlurName"
              label="姓名"
              align="center"
              width="110"
            >
            </el-table-column>
            <el-table-column label="目前階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NowStageName !== null && props.row.NowStageName
                  "
                >
                  <div v-if="props.row.NowStageName.split('(').length > 1">
                    <span>{{ props.row.NowStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NowStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NowStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NowStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column label="下個階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NextStageName !== null && props.row.NextStageName
                  "
                >
                  <div v-if="props.row.NextStageName.split('(').length > 1">
                    <span>{{ props.row.NextStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NextStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NextStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NextStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column
              prop="NextStageExpectStartTime"
              :formatter="timeFormatter"
              align="center"
              label="下個階段開始時間"
            >
            </el-table-column>
            <el-table-column
              prop="FlowExpectEndTime"
              :formatter="timeFormatter"
              align="center"
              label="本日結束時間"
            >
            </el-table-column>
          </el-table>
          <div class="text-right">
            第{{ currentPage }}頁，共{{ Math.ceil(rows.length / pageSize) }}頁
          </div>
        </div>

        <video
          :key="tvData.Sorts[2].Frames[0].Value"
          v-if="tvData.Sorts[2].Frames[0].Type === 3"
          ref="videoRef2"
          :src="tvData.Sorts[2].Frames[0].Value"
          width="100%"
          height="100%"
          muted="muted"
          loop="loop"
          controls
        >
          <!-- 加入字幕 track -->
          <track src="" kind="subtitles" srclang="zh" label="No item" default />
          <!-- 加入視覺描述 track（給視障者輔助） -->
          <track src="" kind="descriptions" srclang="en" label="No item" />
        </video>
        <img
          v-if="tvData.Sorts[2].Frames[0].Type === 4"
          :src="tvData.Sorts[2].Frames[0].Value"
          alt=""
        />
      </div>

      <!-- 右下 -->
      <div
        class="screen"
        v-if="tvData.Sorts[3].Frames.length > 0"
        :class="{
          h100:
            tvData.Sorts[2].Frames.length === 0 &&
            tvData.Sorts[3].Frames[0].Type === 1,
        }"
      >
        <div
          v-if="tvData.Sorts[3].Frames[0].Type === 1"
          class="yahome-table-wrap"
          style="height: 100%; padding: 0"
        >
          <el-table
            :data="
              rows.slice((currentPage - 1) * pageSize, currentPage * pageSize)
            "
            style="width: 100%"
          >
            <el-table-column
              prop="BlurName"
              label="姓名"
              align="center"
              width="110"
            >
            </el-table-column>
            <el-table-column label="目前階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NowStageName !== null && props.row.NowStageName
                  "
                >
                  <div v-if="props.row.NowStageName.split('(').length > 1">
                    <span>{{ props.row.NowStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NowStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NowStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NowStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column label="下個階段名稱" align="center">
              <template slot-scope="props">
                <template
                  v-if="
                    props.row.NextStageName !== null && props.row.NextStageName
                  "
                >
                  <div v-if="props.row.NextStageName.split('(').length > 1">
                    <span>{{ props.row.NextStageName.split("(")[0] }}</span>
                    <br />
                    <span>({{ props.row.NextStageName.split("(")[1] }}</span>
                  </div>
                  <div v-else>
                    {{ props.row.NextStageName }}
                  </div>
                </template>
                <template v-else> {{ props.row.NextStageName }}</template>
              </template>
            </el-table-column>
            <el-table-column
              prop="NextStageExpectStartTime"
              :formatter="timeFormatter"
              align="center"
              label="下個階段開始時間"
            >
            </el-table-column>
            <el-table-column
              prop="FlowExpectEndTime"
              :formatter="timeFormatter"
              align="center"
              label="本日結束時間"
            >
            </el-table-column>
          </el-table>
          <div class="text-right">
            第{{ currentPage }}頁，共{{ Math.ceil(rows.length / pageSize) }}頁
          </div>
        </div>

        <video
          :key="tvData.Sorts[3].Frames[0].Value"
          v-if="tvData.Sorts[3].Frames[0].Type === 3"
          ref="videoRef3"
          :src="tvData.Sorts[3].Frames[0].Value"
          width="100%"
          height="100%"
          muted="muted"
          loop="loop"
          controls
        >
          <!-- 加入字幕 track -->
          <track src="" kind="subtitles" srclang="zh" label="No item" default />
          <!-- 加入視覺描述 track（給視障者輔助） -->
          <track src="" kind="descriptions" srclang="en" label="No item" />
        </video>
        <img
          v-if="tvData.Sorts[3].Frames[0].Type === 4"
          :src="tvData.Sorts[3].Frames[0].Value"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoomScheduleSetting",

  data() {
    return {
      pageSize: 5,
      currentPage: 1,
      rows: [],
      tvData: null,
      timer: null,
      pagingSecond: 10000,
    };
  },
  mounted: function () {},
  methods: {
    getRoomStatus() {
      const vm = this;
      vm.$api.InterviewSch.getIntervieweeStatus().then((response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.rows = response.data.Data;
        }
      });
    },

    getPagingSecond() {
      const vm = this;
      vm.$api.InterviewSch.getPagingSecond().then((response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.pagingSecond = response.data.Data;

          this.timer = setInterval(() => {
            if (this.currentPage * this.pageSize >= this.rows.length) {
              this.getRoomStatus();
              this.currentPage = 1;
            } else {
              this.currentPage += 1;
            }
          }, this.pagingSecond * 1000);
        }
      });
    },

    getShowLobbyTV() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getShowLobbyTV().then(async (response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          let tempData = response.data.Data;
          tempData.Sorts.forEach((item, index) => {
            //如果是影片
            if (item.Frames.length > 0 && item.Frames[0].Type === 3) {
              item.Frames[0].Value =
                `${window.endpoints.api}/InterviewSch/LobbyTV/Video/` +
                item.Frames[0].Value;
            }
            //如果是圖片
            else if (item.Frames.length > 0 && item.Frames[0].Type === 4) {
              vm.getImgDetail(item.Frames[0].Value, index);
            }
          });

          vm.tvData = tempData;

          // 如果table的上下格為空 table會是佔滿高度
          // 1. 定義簡短的 Helper，檢查某個 Sort 是否符合「有內容且 Type 為 1」
          const isTypeOne = (sortIndex) => {
            const frames = vm.tvData.Sorts[sortIndex].Frames;
            return frames.length > 0 && frames[0].Type === 1;
          };

          // 2. 定義簡短的 Helper，檢查某個 Sort 是否為空
          const isEmpty = (sortIndex) => {
            return vm.tvData.Sorts[sortIndex].Frames.length === 0;
          };

          // 3. 將複雜的 FormatId === 2 的邏輯組合起來
          // 邏輯翻譯：(0號位是Type1且1號位空) 或 (1號位是Type1且0號位空) ... 2與3同理
          const isComplexFormat2 =
            vm.tvData.FormatId === 2 &&
            ((isEmpty(1) && isTypeOne(0)) ||
              (isEmpty(0) && isTypeOne(1)) ||
              (isEmpty(3) && isTypeOne(2)) ||
              (isEmpty(2) && isTypeOne(3)));

          if (vm.tvData.FormatId === 1 || isComplexFormat2) {
            vm.pageSize = 8;
          }

          setTimeout(() => {
            this.playVideo();
          }, "1000");
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    playVideo() {
      const vm = this;
      if (
        vm.tvData &&
        vm.tvData.Sorts[0] &&
        vm.tvData.Sorts[0].Frames.length > 0 &&
        vm.tvData.Sorts[0].Frames[0].Type === 3 &&
        vm.tvData.Sorts[0].Frames[0].Value !== null
      ) {
        this.$refs.videoRef0.play();
      }

      if (
        vm.tvData &&
        vm.tvData.Sorts[1] &&
        vm.tvData.Sorts[1].Frames.length > 0 &&
        vm.tvData.Sorts[1].Frames[0].Type === 3 &&
        vm.tvData.Sorts[1].Frames[0].Value !== null
      ) {
        this.$refs.videoRef1.play();
      }

      if (
        vm.tvData &&
        vm.tvData.Sorts[2] &&
        vm.tvData.Sorts[2].Frames.length > 0 &&
        vm.tvData.Sorts[2].Frames[0].Type === 3 &&
        vm.tvData.Sorts[2].Frames[0].Value !== null
      ) {
        this.$refs.videoRef2.play();
      }

      if (
        vm.tvData &&
        vm.tvData.Sorts[3] &&
        vm.tvData.Sorts[3].Frames.length > 0 &&
        vm.tvData.Sorts[3].Frames[0].Type === 3 &&
        vm.tvData.Sorts[3].Frames[0].Value !== null
      ) {
        this.$refs.videoRef3.play();
      }
    },

    // 取得大頭照 API
    getImgDetail(Guid, index) {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      const api = `${window.endpoints.api}/FileUpload/GetResumeHeadPhoto`;

      const params = {
        photoFileGroupId: Guid,
        resetFileStatus: null,
      };

      vm.$http
        .get(api, { params })
        .then((response) => {
          vm.tvData.Sorts[index].Frames[0].Value =
            response.data.HeadPhotoBase64;

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "圖片取得失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    timeFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("HH:mm");
      } else {
        return "";
      }
    },

    checkIsChinese(str) {
      const pattern = /[\u4E00-\u9FA5]+/;
      return pattern.test(str);
    },
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getPagingSecond();
    this.getRoomStatus();
    this.getShowLobbyTV();
  },

  beforeRouteLeave(to, from) {
    console.log("to", to);
    console.log("from", from);
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss">
.screen-list {
  height: 100vh;
  padding-top: 90px;
  display: flex;
  overflow: hidden;
  border: 5px solid #ffedb4;
  background-color: #ffedb4;

  .logo {
    position: fixed;
    top: 7px;
    left: 50%;
    transform: translate(-50%, 0);
    height: 80px;
    object-fit: contain;
  }
  img {
    vertical-align: middle;
    border-style: none;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  .el-table {
    .cell {
      font-size: 18px;
      font-weight: bold;
    }

    th {
      .cell {
        font-size: 16px;
        padding-right: 0;
      }
      .tColumnNonPadding {
        padding-left: 0;
      }
    }
    td {
      .cell {
        padding-right: 0;
        padding-left: 0;
      }
    }
  }

  .screen-wrap {
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .screen {
      height: 50%;

      &.h100 {
        height: 100%;
      }

      video,
      img,
      .yahome-table-wrap {
        border: 5px solid #ffedb4;
      }
    }
  }

  .yahome-table-wrap {
    background-color: #fff;
    margin-left: 30px;
    overflow: hidden;
    border-radius: 10px 10px 0 0;
    th {
      background-color: #303c50 !important;
    }
  }
  .specialName {
    padding-left: 0;
    padding-right: 0;
  }

  .lower-right {
    position: absolute;
    bottom: 0;
    right: 0;
    padding-right: 15px;
    padding-bottom: 4px;
  }
}
</style>
